/**
 * In-memory store for the scanned prescription file.
 * Since this is a SPA, the File object survives navigation within the session.
 */
let _scannedFile = null;

export const setScannedPrescriptionFile = (file) => { _scannedFile = file; };
export const getScannedPrescriptionFile = () => _scannedFile;
export const clearScannedPrescriptionFile = () => { _scannedFile = null; };

/**
 * Saved prescription metadata from a past order (reorder flow).
 * Uses sessionStorage so it survives SPA navigation (cart → checkout).
 */
const RX_REORDER_KEY = "rxReorderPrescriptions";

export const setPendingSavedPrescriptions = (files) => {
  try { sessionStorage.setItem(RX_REORDER_KEY, JSON.stringify(files)); } catch {}
};
export const getPendingSavedPrescriptions = () => {
  try { const v = sessionStorage.getItem(RX_REORDER_KEY); return v ? JSON.parse(v) : null; } catch { return null; }
};
export const clearPendingSavedPrescriptions = () => {
  try { sessionStorage.removeItem(RX_REORDER_KEY); } catch {}
};
